$(document).ready(function () {
  const $popupSlider = $(".c-popup-slider");
  const $slider = $(".c-popup-slider__slider");

  // Function to show the popup
  function showPopup() {
    $popupSlider.addClass("active");
    document.body.style.overflow = 'hidden';
  }

  // Function to close the popup
  function closePopup() {
    $popupSlider.removeClass("active");
    document.body.style.overflow = 'visible';
  }

  // Show popup and navigate to a specific slide
  $(document).on("click", 'a[href^="#popup-slider"]', function (e) {
    e.preventDefault();

    // Extract slide number from href
    const href = $(this).attr("href");
    const slide = href.split('|')[1];

    // Show popup
    showPopup();

    // Go to the specific slide if slide is defined
    if (slide != null) {
      $slider.slick("slickGoTo", parseInt(slide, 10));
    }
  });

  // Close popup on 'Escape' key press
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      closePopup();
    }
  });

  // Close popup on close button click
  $popupSlider.on("click", ".c-popup-slider__close", function () {
    closePopup();
  });

  // Initialize Slick slider with options
  $slider.slick({
    arrows: false,
    dots: true,
    appendDots: $(".c-popup-slider__pagination"),
    fade: true,
    adaptiveHeight: true,
  });

  // Custom buttons for slider navigation
  $(".c-popup-slider__prev-btn").on("click", function () {
    $slider.slick("slickPrev");
  });

  $(".c-popup-slider__next-btn").on("click", function () {
    $slider.slick("slickNext");
  });
});